import {Paragraph} from "../../@types/privacyPolicySectionResources.tsx";
import LegalPageSectionParagraphTransComponent
    from "../legal-pages-components/LegalPageSectionParagraphTransComponent.tsx";
import LegalPageParagraphList from "./LegalPageParagraphList.tsx";
import LegalPageParagraphLetterList from "./LegalPageParagraphLetterList.tsx";

const LegalPageNumericListItem = ({paragraph, locale}: {paragraph: Paragraph, locale?: string}) => {
    return (
        <>
            <li className="mb-4 text-blue-dark">
                <LegalPageSectionParagraphTransComponent text={paragraph.text} locale={locale} />
                {paragraph.list && <LegalPageParagraphList list={paragraph.list} locale={locale} />}
            </li>
            {paragraph.letterList && <LegalPageParagraphLetterList list={paragraph.letterList} locale={locale} />}
        </>
    )
}

export default LegalPageNumericListItem;
